"use client";

import { c as _c } from "react/compiler-runtime";
import { IconCheck, IconMail } from "@tabler/icons-react";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { isEmailValid } from "@/lib/validation";
interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSave: (email: string) => void;
  isPending: boolean;
  isSuccess: boolean;
  isError: boolean;
}
export default function SaveForLaterEmailDialog(t0) {
  const $ = _c(39);
  const {
    open,
    onOpenChange,
    onSave,
    isPending,
    isSuccess,
    isError
  } = t0;
  const [email, setEmail] = useState("");
  const [validationError, setValidationError] = useState("");
  let t1;
  if ($[0] !== email || $[1] !== onSave) {
    t1 = () => {
      if (!isEmailValid(email)) {
        setValidationError("Please enter a valid email address.");
        return;
      }
      setValidationError("");
      onSave(email);
    };
    $[0] = email;
    $[1] = onSave;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleSubmit = t1;
  if (isSuccess) {
    let t2;
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <DialogTitle>Item Saved</DialogTitle>;
      t3 = <DialogDescription className="sr-only">Your item has been saved.</DialogDescription>;
      $[3] = t2;
      $[4] = t3;
    } else {
      t2 = $[3];
      t3 = $[4];
    }
    let t4;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <DialogContent className="max-w-sm">{t2}{t3}<div className="flex flex-col items-center gap-3 py-4 text-center"><IconCheck className="size-10 text-green-600" /><p className="text-sm text-muted-foreground">Check your email to find the link to this item in the future. Thank you for your business!</p></div></DialogContent>;
      $[5] = t4;
    } else {
      t4 = $[5];
    }
    let t5;
    if ($[6] !== onOpenChange || $[7] !== open) {
      t5 = <Dialog open={open} onOpenChange={onOpenChange}>{t4}</Dialog>;
      $[6] = onOpenChange;
      $[7] = open;
      $[8] = t5;
    } else {
      t5 = $[8];
    }
    return t5;
  }
  let t2;
  let t3;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <DialogTitle>Save Your Progress</DialogTitle>;
    t3 = <DialogDescription>We'll save your progress—just enter your email.</DialogDescription>;
    $[9] = t2;
    $[10] = t3;
  } else {
    t2 = $[9];
    t3 = $[10];
  }
  let t4;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Label htmlFor="save-email">Email</Label>;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = e => setEmail(e.target.value);
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== handleSubmit) {
    t6 = e_0 => e_0.key === "Enter" && handleSubmit();
    $[13] = handleSubmit;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== email || $[16] !== t6) {
    t7 = <Input id="save-email" type="email" autoComplete="email" placeholder="you@example.com" value={email} onChange={t5} onKeyDown={t6} />;
    $[15] = email;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== validationError) {
    t8 = validationError && <p role="alert" className="text-sm text-red-600">{validationError}</p>;
    $[18] = validationError;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t7 || $[21] !== t8) {
    t9 = <div className="flex flex-col gap-2">{t4}{t7}{t8}</div>;
    $[20] = t7;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <IconMail />;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  const t11 = isPending ? "Saving..." : "Save Progress";
  let t12;
  if ($[24] !== handleSubmit || $[25] !== isPending || $[26] !== t11) {
    t12 = <Button onClick={handleSubmit} disabled={isPending}>{t10}{t11}</Button>;
    $[24] = handleSubmit;
    $[25] = isPending;
    $[26] = t11;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== isError) {
    t13 = isError && <p role="alert" className="text-sm text-red-600">Failed to save progress. Please try again.</p>;
    $[28] = isError;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <p className="text-xs text-muted-foreground">By submitting this form you agree to opt-in to marketing emails in the future</p>;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== t12 || $[32] !== t13 || $[33] !== t9) {
    t15 = <DialogContent className="max-w-sm">{t2}{t3}<div className="flex flex-col gap-4">{t9}{t12}{t13}{t14}</div></DialogContent>;
    $[31] = t12;
    $[32] = t13;
    $[33] = t9;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] !== onOpenChange || $[36] !== open || $[37] !== t15) {
    t16 = <Dialog open={open} onOpenChange={onOpenChange}>{t15}</Dialog>;
    $[35] = onOpenChange;
    $[36] = open;
    $[37] = t15;
    $[38] = t16;
  } else {
    t16 = $[38];
  }
  return t16;
}